export const parseError = (error: any): string[] => {
  // Handle missing response data
  if (!error?.data) return ["Ha ocurrido un error inesperado"];

  // Return if data is already a string array
  if (Array.isArray(error.data)) return error.data;

  // Extract nested error content from common keys
  const data = error.data.messages || error.data.error || error.data.detail || error.data;

  // Flatten object values into a single array (e.g., { field: [msg] } -> [msg])
  if (typeof data === "object" && data !== null) {
    const rawValues = Object.values(data).flat();

    return rawValues.filter((item) => typeof item === "string") as string[];
  }

  // Fallback for single strings or unknown formats
  return [String(data)];
};
